export const isUndefined = (variable) => (typeof variable === 'undefined')